import { Box } from "@mui/material";
import SearchBox from "components/ui/searchBox";
import { viewAllPayment } from "features/payments/api/payments";
import useApiCall from "hooks/useApiCall";
import { useDebounce } from "hooks/useDebounce";
import { useEffect, useState } from "react";
import PaymentTable from "./PaymentTable";

const Payment = ({ customer_id, project_id }) => {
  const [allPayment, setAllPayment] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [reload, setReload] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
  });
  const debouncedText = useDebounce(searchText, 1000);

  const { data, loading, fetchData: fetchListData } = useApiCall();
  useEffect(() => {
    let finalPagination = { ...pagination };
    fetchListData(
      viewAllPayment,
      {
        body_data: { project_id, customer_id },
        params: `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}&search=${debouncedText}`,
      },
      false
    );
  }, [reload, pagination?.current_page, pagination?.per_page, debouncedText]);

  useEffect(() => {
    if (data) {
      const { data: allData, ...rest } = data;
      setAllPayment(allData);
      setPagination(rest);
    }
  }, [data]);

  return (
    <Box sx={{ m: "-20px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: "10px",
        }}
      >
        <SearchBox
          handleSearch={(text) => setSearchText(text)}
          placeholder={"Search in Payment.."}
        />
      </Box>
      <PaymentTable
        loading={loading}
        allPayment={allPayment}
        setReload={setReload}
        setAllPayment={setAllPayment}
        reload={reload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </Box>
  );
};

export default Payment;
